/*
 * @Author: Tina Huang
 * @Date: 2024-02-19 14:24:52
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2026-01-30 11:01:50
 * @Description:
 */
import { Form, Input, DatePicker, Space, Button, Row, Col, ColorPicker, Select, Radio, Switch } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import locale from 'antd/es/date-picker/locale/zh_CN'

// import 'dayjs/locale/zh-cn'

const { Item, List } = Form
const { RangePicker } = DatePicker
export default function CustomizeForm(props: { id: number }) {
  const { id } = props

  const renderForm = (
    <>
      {/* 极简倒数日 */}
      {(id === 24 || id === 27 || id === 28 || id === 32 || id === 39 || id === 40 || id === 41) && (
        <>
          {id !== 39 && (
            <Item label="事件" name="name">
              <Input placeholder="事件名称不超过5个字" defaultValue={id === 41 ? "2027全国硕士研究生入学考试":""} />
            </Item>
          )}
          <Item label="日期" name="day">
            <DatePicker mode="date" locale={locale} className="w-full" placeholder="选择日期" format="YYYY/MM/DD" />
          </Item>
        </>
      )}
      {/* 限定周 */}
      {id === 15 && (
        <>
          <Item label="说明">
            <strong>不选择周区间</strong>则默认显示当前周（根据当前时间实时更新）
          </Item>
          <Item label="选择周" name="day">
            <DatePicker mode="week" picker="week" locale={locale} className="w-full" placeholder="选择周" />
          </Item>
        </>
      )}
      {/* 人生进度条 */}
      {id === 13 && (
        <>
          <Item label="生日" name="day">
            <DatePicker mode="date" locale={locale} className="w-full" placeholder="选择日期" format="YYYY/MM/DD" />
          </Item>
          <Item label="昵称" name="name">
            <Input placeholder="名称不超过5个字" />
          </Item>
          <Item label="备注" name="msg">
            <Input placeholder="备注文案不超过12个字" />
          </Item>
        </>
      )}
      {/* 多项倒数日 */}
      {(id === 11 || id === 33) && (
        <>
          <Row>
            <Col span={4} className="text-right">
              目标事件：
            </Col>
            <Col span={16}>
              <List name="tasks">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space key={key} align="baseline">
                        <Item {...restField} name={[name, 'name']} wrapperCol={{ span: 24 }} className="w-full">
                          <Input placeholder="事件名称不超过5个字" className="w-full" />
                        </Item>
                        <Item {...restField} name={[name, 'day']} wrapperCol={{ span: 24 }} className="w-full">
                          <DatePicker mode="date" locale={locale} className="w-full" placeholder="选择日期" format="YYYY/MM/DD" />
                        </Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    {fields.length <= 4 && (
                      <Item>
                        <Button type="dashed" className="w-full" onClick={() => add()} block icon={<PlusOutlined />}>
                          新增目标事件
                        </Button>
                      </Item>
                    )}
                  </>
                )}
              </List>
            </Col>
          </Row>
        </>
      )}
      {/* 引用块 */}
      {id >= 1001 && id < 1002 && (
        <Item label="文案" name="content">
          <Input placeholder="这里是文案" />
        </Item>
      )}
      {/* 范围日期 */}
      {id === 29 && (
        <>
          <Item label="高亮颜色" name="highlight">
            <ColorPicker showText />
          </Item>
          <Item label="日期范围" name="date_range">
            <RangePicker locale={locale} format="YYYY/MM/DD" />
          </Item>
        </>
      )}
      {/* 发光时钟 */}
      {id === 30 && (
        <Item label="语言" name="lan">
          <Select
            options={[
              { value: 'cn', label: '中文' },
              { value: 'en', label: '英文' },
            ]}
            placeholder="请选择"
          />
        </Item>
      )}
      {/* 模版按钮 */}
      {id === 1004 && (
        <>
          <Item label="文案" name="btn_name">
            <Input placeholder="按钮文案" />
          </Item>
          <Item label="目标链接" name="link">
            <Input />
          </Item>
          <Item label="尺寸" name="size">
            <Radio.Group
              options={[
                { value: 'normal', label: '默认' },
                { value: 'large', label: '较大' },
              ]}
            />
          </Item>
        </>
      )}
      {/* 区间进度条 */}
      {id === 31 && (
        <>
          <Item label="事件" name="name">
            <Input placeholder="事件名称不超过5个字" />
          </Item>
          <Item label="日期" name="date_range">
            <RangePicker locale={locale} format="YYYY/MM/DD" />
          </Item>
        </>
      )}
      {/* 访客信息 */}
      {id === 1007 && (
        <>
          <Item label="空间名称" name="name">
            <Input placeholder="名称不超过5个字" />
          </Item>
        </>
      )}
      {/* 热榜 */}
      {id === 1008 && (
        <>
          <Item label="站点" name="type">
            <Select
              defaultValue={'wbHot'}
              options={[
                { value: 'wbHot', label: '微博' },
                { value: 'zhihuHot', label: '知乎' },
                { value: 'douyinHot', label: '抖音' },
                { value: 'huPu', label: '虎扑' },
                { value: '36Ke', label: '36氪' },
                { value: 'baiduRD', label: '百度热点' },
                { value: 'bili', label: 'bilibili' },
                { value: 'baiduRY', label: '贴吧热议' },
                { value: 'douban', label: '豆瓣' },
                { value: 'ssPai', label: '少数派' },
              ]}
            />
          </Item>
        </>
      )}
      {/* 欢迎卡片 */}
      {id === 1009 && (
        <>
          <Item label="下班进度条" name="freedom_pro">
            <Input placeholder="如果需要显示下班进度条请输入上下班时间， 如：9:00-18:00" defaultValue="9:00-18:00" />
          </Item>
          <Item label="欢迎语" name="welcome">
            <Input defaultValue="Welcome to Widverse" />
          </Item>
        </>
      )}
      {/* 大数字倒计时 */}
      {id === 41 && (
        <>
          <Item label="备注" name="msg">
            <Input placeholder="备注文案不超过12个字" />
          </Item>
          <Item label="图片" name="cover">
            <Radio.Group
              defaultValue={1}
              options={[
                { value: '1', label: '固定' },
                { value: '0', label: '随机' },
              ]}
            />
          </Item>
        </>
      )}
    </>
  )

  return <>{renderForm}</>
}
